import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "py-6 px-10" }
const _hoisted_2 = { class: "flex items-center justify-between bg-white p-5 rounded-xl" }
const _hoisted_3 = { class: "flex items-center gap-10" }
const _hoisted_4 = { class: "bg-white p-5 rounded-xl mt-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-blue-400 uppercase font-semibold" }, "Статус тайм-слотов")
], -1)
const _hoisted_6 = { class: "flex items-center justify-between mt-5" }
const _hoisted_7 = { class: "flex items-center gap-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog mr-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar mr-2" }, null, -1)
const _hoisted_10 = { class: "mt-5" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, "Произошла ошибка при получении тайм-слотов", -1)
const _hoisted_13 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col gap-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_slot_change_status_modal = _resolveComponent("time-slot-change-status-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loader = _resolveComponent("loader")!
  const _component_time_slot_by_day_item = _resolveComponent("time-slot-by-day-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.change_status_state.is_opened)
      ? (_openBlock(), _createBlock(_component_time_slot_change_status_modal, {
          key: 0,
          "time-slot-id": _ctx.change_status_state.timeSlotId as number,
          "status-id": _ctx.change_status_state.statusId as number,
          onCancel: _ctx.onCancelChangeTimeSlotStatus,
          onSaved: _ctx.onTimeSlotStatusChanged
        }, null, 8, ["time-slot-id", "status-id", "onCancel", "onSaved"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Тайм-слоты" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_input, {
          style: {"min-width":"235px"},
          type: "date",
          placeholder: "Укажите дату",
          value: _ctx.filters_state.date,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.date) = $event)),
          disabled: _ctx.state.is_loading,
          onChange: _ctx.loadTimeSlotsByDay
        }, null, 8, ["value", "disabled", "onChange"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          style: {"min-width":"235px"},
          placeholder: "Сектор диспетчера",
          value: _ctx.filters_state.dispatcherSectorId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.dispatcherSectorId) = $event)),
          "can-deselect": true,
          loading: _ctx.data_state.dispatcher_sectors.is_loading,
          failed: _ctx.data_state.dispatcher_sectors.is_failed,
          options: _ctx.data_state.dispatcher_sectors.list,
          disabled: _ctx.state.is_loading,
          onRefresh: _ctx.loadDispatcherSectors,
          onChange: _ctx.loadTimeSlotsByDay
        }, null, 8, ["value", "loading", "failed", "options", "disabled", "onRefresh", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, { to: "/time-slots/manage" }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "primary small" }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" Управление тайм-слотами ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/time-slots/periods" }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "primary small" }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createTextVNode(" Управление периодами ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_the_select, {
          placeholder: "Тип",
          value: _ctx.filters_state.typeId,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.typeId) = $event)),
          style: {"min-width":"235px"},
          disabled: _ctx.state.is_loading,
          searchable: false,
          options: [{ id: 1, name: 'Забор' }, { id: 2, name: 'Доставка' }],
          onChange: _ctx.loadTimeSlotsByDay
        }, null, 8, ["value", "disabled", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.items.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createBlock(_component_loader, {
                    key: 0,
                    class: "primary"
                  }))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_12,
                      _createVNode(_component_the_button, {
                        class: "small primary mt-2",
                        type: "button",
                        onClick: _ctx.loadTimeSlotsByDay
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Обновить")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      (!_ctx.filters_state.dispatcherSectorId)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Укажите сектор диспетчера")
                          ], 64))
                        : (!_ctx.filters_state.date)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Укажите дату")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode("Данных нет")
                            ], 64))
                    ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.items, (item) => {
                return (_openBlock(), _createBlock(_component_time_slot_by_day_item, {
                  key: item.id,
                  item: item,
                  onChangeStatus: _ctx.onChangeTimeSlotStatus
                }, null, 8, ["item", "onChangeStatus"]))
              }), 128))
            ]))
      ])
    ])
  ]))
}